import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { getEndpointStatusSubdiv } from '../../../apis';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';

const get = (params: { koujiBangou: string }) => async (dispatch: Dispatch<Action<any>>) => {

  try {
    const result = await getEndpointStatusSubdiv(params);
    dispatch(actions.get.done({ params, result }));
  } catch (error) {
    dispatch(actions.get.failed({ params, error: error.toString() }))
    getLogger().error('endpointStatusSubdiv/list()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  }
}

export {
  get
};



// WEBPACK FOOTER //
// ./src/redux/modules/endpointStatusSubdiv/operations.ts